/**
 * Labstep
 *
 * @module core/DropboxPicker
 * @desc DropboxPicker component
 */

import { FileActionCreatePicker as Picker } from 'labstep-web/components/File/Action/Create/Picker';
import { EntityCreateContainer } from 'labstep-web/containers/Entity/Create';
import React from 'react';
import type { IDropboxPickerProps } from './types';

export class DropboxPicker extends React.Component<IDropboxPickerProps> {
  static defaultProps = {
    multiple: false,
  };

  constructor(props: any) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    const { create, options, onSelect, multiple } = this.props;

    const onSuccess = (body: any) => {
      create(body, options);
    };

    window.Dropbox.choose({
      multiselect: multiple,
      success: (files: any) => {
        const filesToUpload = files.map((file: any) => ({
          path: file.link,
          size: file.bytes,
          name: file.name,
          mime_type: file.name.split('.').pop(),
          link_source: 'dropbox',
        }));

        if (onSelect) {
          onSelect(filesToUpload);
        }

        filesToUpload.forEach((file: any) => {
          onSuccess(file);
        });
      },
    });
  }

  render() {
    return (
      <Picker onClick={this.onClick} icon="dropbox" text="Dropbox" />
    );
  }
}

export const DropboxPickerFileContainer = ({
  parentName,
  parentId,
  ...rest
}: any) => (
  <EntityCreateContainer
    entityName="file"
    parentName={parentName}
    parentId={parentId}
  >
    {({ create }) => <DropboxPicker create={create} {...rest} />}
  </EntityCreateContainer>
);
